import { generateExportTimestamp, saveFile } from '@thinkalpha/ui-core/util/csv';
import { unparse } from 'papaparse';

export type CsvCell = string | number | boolean | null | undefined;
export type CsvRow = Record<string, CsvCell>;

export function buildCsvFilename(baseName: string, timestamp: string = generateExportTimestamp()): string {
    const safe = baseName.replace(/[^A-Za-z0-9._-]/g, '_') || 'export';
    return `${safe}-${timestamp}.csv`;
}

/** Build a CSV from row objects (keys become the header) and trigger a browser download. No-op on empty input. */
export function downloadCsvRows(baseName: string, rows: readonly CsvRow[]): void {
    if (rows.length === 0) return;
    const csv = unparse([...rows], { escapeFormulae: true });
    saveFile(buildCsvFilename(baseName), new Blob([csv], { type: 'text/csv' }), 'text/csv');
}
